const paymentMethodTypes = {
	es: {
		"Cash": "Efectivo",
		"Card": "Tarjeta",
		"E-wallets": "Billetera electrónica",
		"Mobile": "Teléfono",
		"Online": "Online",
	},
	en: {
		"Cash": "Cash",
		"Card": "Card",
		"E-wallets": "E-wallets",
		"Mobile": "Mobile",
		"Online": "Online",
	},
    pt: {
        "Cash": "Dinheiro",
        "Card": "Cartão",
        "E-wallets": "Carteira eletrônica",
        "Mobile": "Celular",
        "Online": "Online"
    }
}

export { paymentMethodTypes };